module.exports = __webpack_public_path__ + "static/media/Stellar Ora Single Headboard - 120 cm_Cream.f16ee62b.png";